export const postLogin = `/api/usuario/sesion/login/`;
export const putLogin = `/api/usuario/sesion/logout/`;
export const readPerfiles = `/api/usuario/perfil/read/`;
export const postUsuario = `/api/usuario/create/`;
export const deleteUsuario = ({ idUsuario }) =>
  `/api/usuario/delete/${idUsuario}/`;
